            import * as apiOrg from '@/api/organizations';
import store from '@/store';

export default {
    namespaced: true,
    state: {
        organization: null,
        isFetching: false,
    },

    mutations: {
        SET_ORG(state, payload){
            state.organization = payload;
        },
        SET_FETCH(state, payload){
            state.isFetching = payload;
        },
        SET_DEBT_IMPORT_AUTOMAT(state, payload){
            state.organization.debt_import_automat = payload;
        },
        SET_APPEALS_SERVICE_CONNECTION(state, payload){
            let scIndex = state.organization.serviceConnections.findIndex(sc => sc.service === 'APPEALS');
            if(scIndex !== -1){
                state.organization.serviceConnections.splice(scIndex, 1, payload);
            }else{
                state.organization.serviceConnections.push(payload);
            }      
        },
    },
    getters: {
        serviceConnections(state, getters){
            return getters.IS_EMPTY ? [] : state.organization.serviceConnections;
        },
        appealsServiceConnection(state, getters){
            if(getters.IS_EMPTY){
                return [];
            }
            return state.organization.serviceConnections.find(sc => sc.service === 'APPEALS') || {service: 'APPEALS', status: 'DISCONNECTED', extra: {}};
        },
        ORGANIZATION(state){
            return state.organization;
        },
        IS_ENABLE_DEBT_IMPORT_AUTOMAT(state, getters){
            return ! getters.IS_EMPTY && state.organization.debt_import_automat !== null;
        },
        DEBT_IMPORT_AUTOMAT_LEFT_DAYS(state, getters){
            if(getters.IS_ENABLE_DEBT_IMPORT_AUTOMAT){
                return state.organization.debt_import_automat.leftDays;
            }
            return null;
        },
        IS_EMPTY(state){
            return state.organization === null;
        },

        IS_FETCHING(state) {
            return state.isFetching === true;
        },
        WORK_SPACE_ID(state, getters){
            return getters.IS_EMPTY ? null : state.organization.work_space_id;
        },

        ID_ORG(state){
            return state.organization !== null ? state.organization.id : null;
        },
        SHORT_NAME(state, getters){
            return getters.IS_EMPTY ? '---' : state.organization.short_name;
        },
        DEBT_RESULTS_STATUS(state, getters){
            return getters.IS_EMPTY ? null : state.organization.debt_result_status_connection;
        },
        DEBT_RESULTS_CONNECTION_LAST(state, getters){
            return getters.IS_EMPTY ? null : state.organization.last_debt_result_connection;
        },
        DEBT_RESULTS_CONNECTION_EXCHANGE_STATUS(state, getters){
            return ! getters.IS_EMPTY && state.organization.last_debt_result_connection ? 
                    state.organization.last_debt_result_connection.exchange_status : null;
        },
    },

    actions: {
        setAppealsServiceConnectionStatusConnection({ commit, getters }){
            commit('SET_APPEALS_SERVICE_CONNECTION', {... getters.appealsServiceConnection, ...{status: 'CONNECTION'}});
        },
        async TOGGLE_DEBT_IMPORT_AUTOMAT({commit, getters}){
            if( ! getters.IS_ENABLE_DEBT_IMPORT_AUTOMAT ){
                if( ! store.getters['organizationExecutor/HAS_EXECUTOR'] ){
                    store.dispatch('notifications/SHOW_ERROR', 'Не назначен отправитель!');
                    return Promise.reject('Не назначен отправитель!');
                }
                let {data} = await apiOrg.enableDebtImportAutomat(getters.WORK_SPACE_ID, getters.ID_ORG, {organization_executor_id: store.getters['organizationExecutor/EXECUTOR_ID']});
                commit('SET_DEBT_IMPORT_AUTOMAT', data.model);
                store.dispatch('notifications/SHOW_SUCCESS', data.message);
            }else{
                let {data} =  await apiOrg.disableDebtImportAutomat(getters.WORK_SPACE_ID, getters.ID_ORG);
                commit('SET_DEBT_IMPORT_AUTOMAT', null);
                store.dispatch('notifications/SHOW_SUCCESS', data.message);
            }
        },
        SET_ORGANIZATION({ commit }, payload){
            commit('SET_ORG', payload);
        },
        SET_FETCH({ commit }, {fetch = true}){
            commit('SET_FETCH', fetch);
        },
        async DEBT_RESULT_DELETE({ getters }, {debtConnectionId}){
            let res = await apiOrg.debtResultsConnectionDelete(getters.WORK_SPACE_ID, getters.ID_ORG, debtConnectionId);
            store.dispatch('workspace/RELOAD_ORGANIZATION');
            return res;
        }
    },
}